import { jsx as o } from "react/jsx-runtime";
import m from "@mui/icons-material/Event";
import { IconButton as r } from "@mui/joy";
import i from "../../../../node_modules/lodash-es/omit.js";
const t = (t2) => o(r, { ...i(t2, ["fillMode", "svgIcon"]), children: o(m, { sx: { path: { fill: "rgba(0, 0, 0, 0.54)" } } }) });
export {
  t as CustomToggleButton
};
//# sourceMappingURL=CustomToggleButton.js.map
